import {ColorValue, Pressable, PressableProps, StyleProp, StyleSheet, ViewStyle} from "react-native";
import {DimensionValue} from "react-native/Libraries/StyleSheet/StyleSheetTypes";

interface BtnProps extends PressableProps {
  p?: DimensionValue;
  pt?: DimensionValue;
  pr?: DimensionValue;
  pb?: DimensionValue;
  pl?: DimensionValue;
  px?: DimensionValue;
  py?: DimensionValue;
  rounded?: number;
  roundedTopLeft?: number;
  roundedTopRight?: number;
  roundedBottomLeft?: number;
  roundedBottomRight?: number;
  roundedTop?: number;
  roundedLeft?: number;
  roundedRight?: number;
  roundedBottom?: number;
  minH?: DimensionValue;
  minW?: DimensionValue;
  maxH?: DimensionValue;
  maxW?: DimensionValue;
  h?: DimensionValue;
  w?: DimensionValue;
  row?: boolean;
  justifyContent?: ViewStyle['justifyContent'];
  alignItems?: ViewStyle['alignItems'];
  alignSelf?: ViewStyle['alignSelf'];
  borderWidth?: number;
  borderColor?: string;
  borderStyle?: ViewStyle['borderStyle'];
  flex?: ViewStyle['flex'];
  gap?: number;
  bg?: ColorValue;
  m?: DimensionValue;
  mt?: DimensionValue;
  mr?: DimensionValue;
  mb?: DimensionValue;
  ml?: DimensionValue;
  mx?: DimensionValue;
  my?: DimensionValue;
  opacity?: number;
  borderBottomWidth?: number;
  position?: ViewStyle['position'];
  bottom?: number;
  left?: number;
  right?: number;
  top?: number;
  zIndex?: number;
  overflow?: ViewStyle['overflow'];
  column?: boolean
}

const Btn = (props: BtnProps) => {
  const {
    children, minH, minW, maxH, maxW, w, h, p, pt, pr, pb, pl, px, py, row, justifyContent, alignItems, alignSelf, rounded,
    roundedBottom, roundedTopLeft, roundedBottomRight, roundedBottomLeft, roundedTopRight, roundedTop, roundedLeft,
    roundedRight, borderWidth, borderColor, borderStyle, flex, gap, bg, mb, mx, m, ml, my, mr, mt, opacity, borderBottomWidth,
    position, left, right, bottom, top, zIndex, overflow, column, ...rest
  } = props;

  let style: StyleProp<ViewStyle> = {
    ...(minH ? {minHeight: minH} : {}),
    ...(minW ? {minWidth: minW} : {}),
    ...(maxH ? {maxHeight: maxH} : {}),
    ...(maxW ? {maxWidth: maxW} : {}),
    ...(h ? {height: h} : {}),
    ...(w ? {width: w} : {}),
    ...(p ? {padding: p} : {}),
    ...(pt ? {paddingTop: pt} : {}),
    ...(pr ? {paddingRight: pr} : {}),
    ...(pb ? {paddingBottom: pb} : {}),
    ...(pl ? {paddingLeft: pl} : {}),
    ...(px ? {paddingHorizontal: px} : {}),
    ...(py ? {paddingVertical: py} : {}),
    ...(row ? {flexDirection: 'row'} : {}),
    ...(justifyContent ? {justifyContent} : {}),
    ...(alignItems ? {alignItems} : {}),
    ...(alignSelf ? {alignSelf} : {}),
    ...(rounded ? {borderRadius: rounded} : {}),
    ...(roundedTopLeft ? {borderTopLeftRadius: roundedTopLeft} : {}),
    ...(roundedTopRight ? {borderTopRightRadius: roundedTopRight} : {}),
    ...(roundedBottomLeft ? {borderBottomLeftRadius: roundedBottomLeft} : {}),
    ...(roundedBottomRight ? {borderBottomRightRadius: roundedBottomRight} : {}),
    ...(roundedTop ? {borderTopLeftRadius: roundedTop, borderTopRightRadius: roundedTop} : {}),
    ...(roundedLeft ? {borderTopLeftRadius: roundedLeft, borderBottomLeftRadius: roundedLeft} : {}),
    ...(roundedRight ? {borderTopRightRadius: roundedRight, borderBottomRightRadius: roundedRight} : {}),
    ...(roundedBottom ? {borderBottomLeftRadius: roundedBottom, borderBottomRightRadius: roundedBottom} : {}),
    ...(borderWidth ? {borderWidth} : {}),
    ...(borderColor ? {borderColor} : {}),
    ...(borderStyle ? {borderStyle} : {}),
    ...(flex ? {flex} : {}),
    ...(bg ? {backgroundColor: bg} : {}),
    ...(m ? {margin: m} : {}),
    ...(mt ? {marginTop: mt} : {}),
    ...(mr ? {marginRight: mr} : {}),
    ...(mb ? {marginBottom: mb} : {}),
    ...(ml ? {marginLeft: ml} : {}),
    ...(mx ? {marginHorizontal: mx} : {}),
    ...(my ? {marginVertical: my} : {}),
    ...(opacity !== undefined ? {opacity} : {}),
    ...(borderBottomWidth ? {borderBottomWidth} : {}),
    ...(position ? {position} : {}),
    ...(gap ? {gap} : {}),
    ...(top !== undefined ? {top} : {}),
    ...(left !== undefined ? {left} : {}),
    ...(right !== undefined ? {right} : {}),
    ...(bottom !== undefined ? {bottom} : {}),
    ...(zIndex !== undefined ? {zIndex} : {}),
    ...(overflow !== undefined ? {overflow} : {}),
    ...(column ? {flexDirection: 'column'} : {}),
  };

  const combinedStyle = props && props.style ? StyleSheet.flatten(props.style) : {};
  style = {...style, ...combinedStyle};
  if (rest && rest.style) delete rest.style;

  return (
    <Pressable style={StyleSheet.flatten(style)} {...rest}>{children}</Pressable>
  );
};

export default Btn;
